import { render, staticRenderFns } from "./UserClassifiedsPetsArchive.vue?vue&type=template&id=cddce9bc&scoped=true&"
import script from "./UserClassifiedsPetsArchive.vue?vue&type=script&lang=js&"
export * from "./UserClassifiedsPetsArchive.vue?vue&type=script&lang=js&"
import style0 from "./UserClassifiedsPetsArchive.vue?vue&type=style&index=0&id=cddce9bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cddce9bc",
  null
  
)

export default component.exports